<template>
  <div  class="action-card">
    <h2><i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{title}}</h2>
    <hr/>
    <slot></slot>
  </div>
</template>
<style lang="scss" scoped>
@import '~scss/colors.scss';

#action-card {
  border:1px solid $red;
  background-color:white;
  h2 {
    color: $red;
  }
}
</style>
<script>
  export default{
    props:{
      title:{
        type:String,
        required:true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/editor/WarningBox.vue